export default __webpack_public_path__ + "5527f6fae5db12a71b95a380459b69a8.png";